import { Alert, EventType } from 'mcsclient/models';

import {
  DeviceAntiphishingSettingEventTypes,
  deviceAntiphishingSettingEventTypes,
  DeviceAutoSampleSubmissionEventTypes,
  deviceAutoSampleSubmissionEventTypes,
  DeviceEventTypes,
  DeviceRtpSettingEventTypes,
  deviceRtpSettingEventTypes,
  DeviceSettingEventTypes,
  deviceSettingEventTypes,
  DeviceThreatEventTypes,
  deviceThreatEventTypes,
  DeviceUnsafeUrlEventTypes,
  deviceUnsafeUrlEventTypes,
  ISecureConnectionAlertBody,
  SecureConnectionVpnMonthlyQuotaEventTypes,
} from './alerts.types';

const supportsHistoryEventTypes: EventType[] = [...deviceSettingEventTypes, ...deviceThreatEventTypes, ...deviceUnsafeUrlEventTypes];

export function alertHasHistory(alert: Alert): alert is Alert & { artifactType: 'Device'; eventType: DeviceEventTypes } {
  return alert.artifactType === 'Device' && supportsHistoryEventTypes.includes(alert.eventType);
}

export function isDeviceSettingEventType(alert: Alert): alert is Alert & { eventType: DeviceSettingEventTypes } {
  const types: ReadonlyArray<EventType> = deviceSettingEventTypes;
  return types.includes(alert.eventType);
}

export function isDeviceRtpSettingEventType(alert: Alert): alert is Alert & { eventType: DeviceRtpSettingEventTypes } {
  const types: ReadonlyArray<EventType> = deviceRtpSettingEventTypes;
  return types.includes(alert.eventType);
}

export function isDeviceAntiphishingSettingEventType(
  alert: Alert
): alert is Alert & { eventType: DeviceAntiphishingSettingEventTypes } {
  const types: ReadonlyArray<EventType> = deviceAntiphishingSettingEventTypes;
  return types.includes(alert.eventType);
}

export function isDeviceAutoSampleSubmissionType(alert: Alert): alert is Alert & { eventType: DeviceAutoSampleSubmissionEventTypes } {
  const types: ReadonlyArray<EventType> = deviceAutoSampleSubmissionEventTypes;
  return types.includes(alert.eventType);
}

export function isDeviceThreatEventType(alert: Alert): alert is Alert & { eventType: DeviceThreatEventTypes } {
  const types: ReadonlyArray<EventType> = deviceThreatEventTypes;
  return types.includes(alert.eventType);
}

export function isDeviceUnsafeUrlEventType(alert: Alert): alert is Alert & { eventType: DeviceUnsafeUrlEventTypes } {
  const types: ReadonlyArray<EventType> = deviceUnsafeUrlEventTypes;
  return types.includes(alert.eventType);
}

export function isSecureConnectionVpnMonthlyQuota100(
  alert: Alert
): alert is Alert & { eventType: SecureConnectionVpnMonthlyQuotaEventTypes } {
  const secureConnectionAlertBody = alert.body as ISecureConnectionAlertBody;
  return secureConnectionAlertBody.vpnBandwidthConsumptionPercentage === '100';
}
